/**
 * Dev/prod-gated logging.
 *
 * Each method checks `process.env.NODE_ENV` inline (not via a top-level
 * constant). CRA's DefinePlugin substitutes the value at build time, then
 * Terser eliminates the dead branch in production bundles. Verify with
 * `bash verify-dead-code-elimination.sh` after build — the script greps the
 * minified output for our log category strings.
 *
 * Production: silent (or in the future, route to Sentry / backend logging).
 * Development: full `console.error` with `[CATEGORY]` prefix.
 *
 * Categories are short, stable identifiers (e.g., 'AUTH_REFRESH',
 * 'MARKET_CONTEXT_FETCH'). They never appear in production bundles.
 */

export const log = {
  error: (category, error) => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error(`[${category}]`, error);
    }
  },
  warn: (category, msg) => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`[${category}]`, msg);
    }
  },
  info: (category, msg) => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log(`[${category}]`, msg);
    }
  },
};
